import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./info-banner.module.css";
var infoText = "cinch joins the nation in expressing our gratitude for the lifelong commitment made by HM Queen Elizabeth II and sends our condolences to the Royal Family.";
export default function() {
    return /*#__PURE__*/ _jsx("p", {
        className: styles.text,
        children: infoText
    });
};
